import authRules from '../authRules';

const changeAssignmentsResource = (user) => {
  const { changeAssignmentsResource } = user.securityLevels;
  if (changeAssignmentsResource >= authRules.changeAssignmentsResource.changeAssignmentsResource) {
      return true;
  } else {
      return false;
    }
  }


export default changeAssignmentsResource;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/changeAssignmentsResource.js